import state from './store';

export const registerElToObserverList = (el: HTMLElement, cb: (el: HTMLElement) => void): IntersectionObserver => {
    if (!state.observer) {
        state.observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Look up the element's associated callback and call it
                        const callback = state.elementRegister.get(entry.target as HTMLElement);
                        if (callback) {
                            callback(entry.target as HTMLElement);
                        }

                        // Unobserve the element
                        state.observer.unobserve(entry.target);
                    }
                });
            },
            { rootMargin: '0px 0px 100px 0px' }
        );
    }

    observeElement(el, cb);

    return state.observer;
};

export function observeElement(el: HTMLElement, callback: (el: HTMLElement) => void) {
    // Associate the element with the callback
    state.elementRegister.set(el, callback);
    // Observe the element with the shared observer
    state.observer.observe(el);
}
